import { render, staticRenderFns } from "./getOpenId.vue?vue&type=template&id=600c27b0&"
import script from "./getOpenId.vue?vue&type=script&lang=js&"
export * from "./getOpenId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports